module.exports = __webpack_public_path__ + "img/side_avg.8a5f6099.png";